import axios from "axios";
import ErrorResolver from "./ErrorResolver";
import GateWays from "./GateWays";

let tagId = 'paymentTagId'

let gConfig = null;

let scriptExists = function(){
    let d = document.getElementById(tagId)
    return d != null
}

let createTag = function(link, cb){
    // dont execute if script already exists
    // if(scriptExists())
    //     return

    let paymentScript = document.createElement('script')
    paymentScript.setAttribute('id', tagId)
    paymentScript.setAttribute('src', link)
    document.head.appendChild(paymentScript)
    paymentScript.onload = function(){
        if(cb !== undefined && cb !== 'undefined' && cb !== null){
            cb();
        }
    }
}

let loadScript = function(script, cb){
    createTag(script, cb)
}


/* ************************** Paystack payment config ******************** */
let payWithPaystack = function({email, amount, currency, invoice, paymentId}, vm, verificationLink, callback, preferredServerCallback){
    // eslint-disable-next-line no-undef
    var handler = PaystackPop.setup({
        key: gConfig.publicKey, // from config APIKeys.PUBLIC_KEY,
        email: email,
        amount: amount * 100, //
        currency: currency, // will be changed base on nationality
        ref: invoice,
        metadata: {
            trx: paymentId
        },

        // eslint-disable-next-line no-unused-vars
        callback: function(response){
            // use preferred callback
            if(preferredServerCallback !== undefined){
                preferredServerCallback(response.reference)
            } else{ // user
                if(verificationLink !== undefined){
                    vm.loading = true
                    axios.put(verificationLink +(verificationLink.endsWith("/") ? '' : '/') + response.reference)
                        .then(res => {
                            vm.message = 'Transaction Completed and Verified!'
                            vm.messageType = 'success'
                            vm.messageShow = true
                            callback(res.data)
                        }).catch(err => ErrorResolver.checkErrors(vm, err))
                        .finally(() => vm.loading = false)
                }
            }
        },

        onClose: function (){
            vm.message = "Transaction cancelled by user";
            vm.messageType = 'info';
            vm.messageShow = true;
        }
    });

    handler.openIframe();
}

let payWithRemita = function(rrr, gateway, callback){
    // create extended data
    let data = {
        "customFields": [
            {
                name: "rrr",
                value: rrr
            }
        ]
    }

    // payment engine
    // eslint-disable-next-line no-undef
    var paymentEngine = RmPaymentEngine.init({
        key: gateway.publicKey,
        processRrr: true,
        extendedData: data,
        // eslint-disable-next-line no-unused-vars
        onSuccess: function (response) {
            callback(rrr);
            // setTimeout(() => {
            //     window.location.reload();
            // }, 3000)
        },
        onError: function (response) {
            console.log('callback Error Response', response);
        },
        onClose: function () {
            console.log("closed");
        }

    });
    // call method
    paymentEngine.showPaymentWidget();
}

/**
 * Class covers all payment logic. enables the use of multiple payment gateways
 */
export class PaymentGateway {
     constructor(gateWay, vm, verificationLink) {
         this.gateWay = gateWay;
         this.vm = vm
         this.verificationLink = verificationLink
         this.gConfig = null
     }

    /**
     * Must be called first before calling any other method
     * Loads the script(js sdk) required
     * @param config configuration file containing paymentLink(js inline) and public(merchant key)
     * @param cb a function
     */
    initializeGateway(config, cb = undefined){
        // set gateway
        this.gateWay = config.name
        // if gateway is provided
        if(!this.gateWay){
            throw new Error("No gateway defined")
        }

        if(!config){
            throw new Error("Config must be a valid object")
        }

        this.gConfig = config

        this.gateWay = this.gConfig.name

        // load appropriate script
        loadScript(config.paymentLink, cb)
    }

    /**
     * Call method after all required data for payment are ready
     * @param email the email of the customer
     * @param amount th amount to be pid
     * @param currency the currency to pay in
     * @param invoice invoice number
     * @param paymentId some special id to some entity on the database
     * @param callback callback after the call to server
     * @param preferredServerCallback if provided, a call wont be made to the server. instead, this method will be called with the reference passed to it
     */
     makePayment({email, amount, currency, invoice, paymentId}, callback, preferredServerCallback){
         // if gateway is provided
         if(!this.gateWay){
             throw new Error("No gateway defined")
         }

         if(this.gateWay === GateWays.PAYSTACK)
             payWithPaystack({email, amount, currency, invoice, paymentId}, this.vm, this.verificationLink, callback, preferredServerCallback)

        else if(this.gateWay === GateWays.REMITA)
            payWithRemita(invoice, this.gConfig, preferredServerCallback)
     }
 }
